export type { Props as LinkProps } from './link';
export { Link } from './link';
